import { render, staticRenderFns } from "./AboutInfoBanner.vue?vue&type=template&id=307f88a8"
import script from "./AboutInfoBanner.vue?vue&type=script&lang=js"
export * from "./AboutInfoBanner.vue?vue&type=script&lang=js"
import style0 from "./AboutInfoBanner.vue?vue&type=style&index=0&id=307f88a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports